import { IPiece, EffectType, Direction } from "../../../types";
import {
  ISideEffectHandler,
  SideEffectHandlerParams,
} from "./SideEffectHandler";

export class RotateHandler implements ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void {
    const { inflictingPiece, sideEffects } = params;

    // Process each rotation side effect
    sideEffects.forEach((sideEffect) => {
      if (sideEffect.effect.type === EffectType.rotate) {
        // Get the rotation direction from the side effect
        const rotateDirection = (sideEffect as any)
          .rotateDirection as Direction;

        if (rotateDirection) {
          // Update the piece's direction
          inflictingPiece.direction = rotateDirection;

        }
      }
    });
  }
}
